import React from 'react';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import {
    HeaderWrapper,
    HeaderTitle,
    CasinoIconBox,
    PlayNowButton,
    CloseWidgetIcon,
} from 'src/domains/casino/webview/CasinoGames/mini-games/mini-games-grid/grid-header/GridHeader.style';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { UniverseComponent } from 'src/domains/common/universes';

interface GridHeaderPropsType {
    appCasinoState: AppCasinoState;
}

export const GridHeader = observer('GridHeader', ({ appCasinoState }: GridHeaderPropsType) => {
    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);

    const { isGamesListDisplayed, showGamesList, hideGamesList } = appCasinoState.miniGamesListState;
    const desktopVersion = breakpointsState.desktop.isBiggerOrEq === true;

    const renderButton = (): JSX.Element | null => {
        if (desktopVersion === true) {
            return null;
        }

        return isGamesListDisplayed ? (
            <CloseWidgetIcon onClick={hideGamesList} />
        ) : (
            <UniverseComponent>
                {(universeModule): React.ReactElement => (
                    <PlayNowButton
                        onClick={showGamesList}
                        size='x-small'
                        appearance={universeModule.miniCasinoButtons.playButton}
                    >
                        <I18n
                            langKey='casino.mini-games-widget.button'
                            defaultText='Play Now'
                        />
                    </PlayNowButton>
                )}
            </UniverseComponent>
        );
    };

    return (
        <HeaderWrapper>
            <CasinoIconBox />

            <HeaderTitle data-test='mini-games-header'>
                <I18n
                    langKey='casino.mini-games-widget.title'
                    defaultText='Casino Mini Games'
                />
            </HeaderTitle>

            {renderButton()}
        </HeaderWrapper>
    );
});
